import RelationshipMetadata from "../../RelationshipMetadata";

class RolePrivilegeRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "RolePrivilegeRelationshipMetadata";
        this.parentEnterpriseComponent = "Role";
        this.childEnterpriseComponent = "RolePrivilege";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "RoleUSID";
    }
}

export default RolePrivilegeRelationshipMetadata;